<h1 class="h5">Reports</h1>

<ul class="nav nav-tabs mb-3" id="reportTabs" role="tablist">
  <li class="nav-item" role="presentation">
    <a class="nav-link" routerLink="/reports/daily" routerLinkActive="active">Daily Report</a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link" routerLink="/reports/subid" routerLinkActive="active">SubID Summary</a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link" routerLink="/reports/offer" routerLinkActive="active">Offer Report</a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link" routerLink="/reports/conversion" routerLinkActive="active">Conversion Report</a>
  </li>
  <li class="nav-item" role="presentation">
    <a class="nav-link" routerLink="/reports/click" routerLinkActive="active">Click Report</a>
  </li>
</ul>

<div class="card card-body border-0 shadow">
  <button class="btn btn-primary w-100 fw-bold d-block d-lg-none mb-2" type="button" data-bs-toggle="collapse"
    data-bs-target="#filters" aria-expanded="false" aria-controls="filters">
    <i class="bi bi-funnel"></i>Filters
  </button>

  <form [formGroup]="filters" (ngSubmit)="onSubmit()" id="filters" class="collapse filters">
    <div class="row mb-3 g-2">
      <div class="col-lg-2">
        <div class="d-flex">
          <app-dropdown-select placeholder="All Offers" formControlName="offerIds" [multiple]="true" class="w-100">
            @for (offer of offers; track offer) {
              <app-dropdown-select-option [value]="offer.id">
                {{ offer }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
      </div>

      <div class="col-lg-2">
        <input formControlName="subid" type="text" class="form-control form-control-sm" placeholder="SUBID">
      </div>

      <div class="col-6 col-lg-2">
        <input formControlName="tc1" type="text" class="form-control form-control-sm" placeholder="Tracker1">
      </div>

      <div class="col-6 col-lg-2">
        <input formControlName="tc2" type="text" class="form-control form-control-sm" placeholder="Tracker2">
      </div>

      <div class="col-6 col-lg-2">
        <input formControlName="tc3" type="text" class="form-control form-control-sm" placeholder="Tracker3">
      </div>

      <div class="col-6 col-lg-2">
        <input formControlName="tc4" type="text" class="form-control form-control-sm" placeholder="Tracker4">
      </div>

      <div class="col-lg-8">
        <app-date-range-selector (dateChanged)="updateRange($event)"
          (dateRangeInvalidChange)="dateRangeInvalid = $event"
          [showTimezone]="false"
          [date]="savedDate?.selector ?? 'this-month'"
          [initialFrom]="savedDate?.from ?? ''"
        [initialTo]="savedDate?.to ?? ''"></app-date-range-selector>
      </div>

      <div class="col-lg text-end">
        @if (!loader.isLoading()) {
          <button type="button" class="btn btn-purple btn-sm fw-bold me-2" (click)="exportCsv()"
            [disabled]="exportProgress !== null">
            @if (exportProgress !== null) {
              <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              Exporting{{ exportProgress.total > 1 ? ' ' + exportProgress.current + '/' + exportProgress.total : '' }}…
            } @else {
              <i class="bi bi-file-earmark-spreadsheet"></i> Export CSV
            }
          </button>
        }
        <button type="submit" class="btn btn-primary btn-sm fw-bold" [disabled]="dateRangeInvalid">Filter</button>
      </div>
    </div>
  </form>

  <router-outlet></router-outlet>
</div>
